import { filament, stockItem, product, sale, production, purchase, movement, settingsDoc } from './mappers.js';
import { supabase } from './supabase.js';

const PAGE = 1000;
// O PostgREST limita cada resposta; sem paginar, dados acima de 1.000 linhas sumiriam sem erro.
export async function fetchAll(table, ws, { order = 'id', ascending = true, notDeleted = true, client = supabase } = {}) {
  const out = [];
  for (let from = 0; ; from += PAGE) {
    let q = client.from(table).select('*').eq('workspace_id', ws).order(order, { ascending }).range(from, from + PAGE - 1);
    if (notDeleted) q = q.is('deleted_at', null);
    const { data, error } = await q;
    if (error) throw error;
    out.push(...data);
    if (data.length < PAGE) return out;
  }
}
const vmap = rows => Object.fromEntries(rows.map(r => [r.id, r.row_version]));

export async function loadWorkspace(ws, client = supabase) {
  const get = (t, o) => fetchAll(t, ws, { ...o, client });
  const [fil, items, prod, vars, mats, imgs, sal, sit, pro, pmat, cmp, mov, mk, media, st] = await Promise.all([
    get('filaments'), get('stock_items'), get('products'), get('product_variations'),
    get('variation_materials', { order: 'variation_id', notDeleted: false }), get('product_images', { order: 'product_id', notDeleted: false }),
    get('sales'), get('sale_items', { order: 'sale_id', notDeleted: false }), get('productions'),
    get('production_materials', { order: 'production_id', notDeleted: false }), get('purchases'),
    get('stock_movements', { order: 'seq', ascending: false, notDeleted: false }),
    get('marketplace_settings', { order: 'channel', notDeleted: false }), get('media_assets'),
    client.from('system_settings').select('*').eq('workspace_id', ws).maybeSingle().then(r => { if (r.error) throw r.error; return r.data; }),
  ]);
  const of = kind => items.filter(i => i.kind === kind).map(stockItem.fromRow);
  const entries = {
    print3d_products: JSON.stringify(prod.map(r => product.fromRow(r, vars, mats, imgs))),
    print3d_settings: JSON.stringify(settingsDoc.fromRows(st, mk)),
    print3d_filamentos: JSON.stringify(fil.map(filament.fromRow)),
    print3d_insumos: JSON.stringify(of('insumo')), print3d_embalagens: JSON.stringify(of('embalagem')), print3d_outros: JSON.stringify(of('outro')),
    print3d_mov: JSON.stringify(mov.map(movement.fromRow)),
    print3d_vendas: JSON.stringify(sal.map(r => sale.fromRow(r, sit))),
    print3d_producoes: JSON.stringify(pro.map(r => production.fromRow(r, pmat))),
    print3d_compras: JSON.stringify(cmp.map(purchase.fromRow)),
    print3d_version: '3.6',
  };
  const versions = {
    filaments: vmap(fil), stock_items: vmap(items), products: vmap(prod), sales: vmap(sal), productions: vmap(pro), purchases: vmap(cmp),
    marketplace_settings: Object.fromEntries(mk.map(m => [m.channel, m.row_version])),
    system_settings: { settings: st?.row_version ?? 1 },
  };
  return { entries, versions, media };
}

export const rpc = async (fn, args, client = supabase) => {
  const { data, error } = await client.rpc(fn, args);
  if (error) throw error;
  return data;
};
